//import fetch from "./components/fetchWithTimeout";

//let api = 'http://192.168.1.10:5000/';
//let api = 'http://localhost:5000/';
let api=""
let name_host=""
//if(process.env.NODE_ENV === 'production'){
  //  api = 'https://192.168.1.10:5002/'
    //api = 'https://invapi.localhost/back/'
//}
//else{
  //  api = 'https://localhost:5002/';
   // api = 'https://192.168.1.10:5002/'
//}

name_host = window.location.hostname
api = 'https://'+name_host+':5002/'

const originalFetch = window.fetch;
window.fetch = async (url, options = {}) => {
    // 1. Forzamos la regla de la API Fetch para que nunca guarde ni use caché
    options.cache = 'no-store'; 
    
    // 2. Ejecutamos la petición original
    const response = await originalFetch(url, options);

    // 3. Interceptamos automáticamente si el servidor responde con HTTP 403
    if (response.status === 403) {
        // Clonamos la respuesta para poder leer su JSON sin consumir el stream de la respuesta principal
        const responseClone = response.clone();
        
        try {
            const data = await responseClone.json();
            const detail = data.detail || "";

            if (detail.includes("MUST_CHANGE_PASSWORD")) {
                alert("Atención: Debes cambiar tu contraseña en Gestión antes de continuar utilizando el sistema. Recuerda conectarte a internet y usar el botón actualizar luego de hacerlo.");
            } else {
                alert("Acceso Prohibido (403): " + detail);
            }
        } catch (e) {
            console.error("Error leyendo respuesta 403:", e);
        }
    }

    return response;
};

export const loginResources = {
    login(state){
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(state)
        };
        return fetch(api + 'token', requestOptions);
    },
    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('datos');
    },
    verificaEncargadoTienda(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "verifica_encargado_tienda" , requestOptions);
    },

};

export const inventarioResources = {
    agregarEnvases(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token }
        };
        return fetch(api + "agregar_envases" , requestOptions);
    },
    iniciarInv(folio,app,idCliente){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "inv/init/"+ folio + "/" + app + "/" + idCliente, requestOptions);
    },
    verificaInicializado(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api+ "verifica/inicializado/"+ folio , requestOptions);
    },
    getInvDisponibles(page, pageSize, search) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 50,
            search: search ?? ""
        });
        const token = localStorage.getItem('token');
        return fetch(`${api}/inv_disponibles?${params.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        });
    },
    cambiarInv(folio, id_cliente){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {'Authorization': "Bearer "+ token },
        };
        return fetch(api + 'actualizar_token/' + folio + "/" + id_cliente, requestOptions);
    },
    agregarIniciarInv(invNuevo,idCliente){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(invNuevo)
        };
        return fetch(api + "crear_inventario/" + idCliente , requestOptions);
    },
    getInvProgramados(tienda, fecha){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "inv_programdos/" + tienda +"/"+ fecha, requestOptions);
    },
    getInvProgramadosDia(tienda, fecha){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "inv_programdos_dia/" + tienda +"/"+ fecha, requestOptions);
    },
    respaldarInv(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "generar_respaldo_bd/"+ folio, requestOptions);
    },
    importarRespaldo(formData){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers:{'Authorization': "Bearer "+ token},
            body: formData
        };
        return fetch(api + 'importar_respaldo', requestOptions)
    },
    modificarEstadoInv(folio,estado){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'modificar_estado_inventario/'+ folio +'/' + estado, requestOptions);
    },
    gestionUpdate(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'gestion/update', requestOptions);
    },
    enviarInventario(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'enviar_archivo/'+folio, requestOptions);
    },
    archivarInventario(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'archivar/'+folio, requestOptions);
    },
    conteosEliminados(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'get_eliminados', requestOptions);
    },
    getEliminadosTag(tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'conteos/eliminados/tag/'+ tag, requestOptions);
    },
    getPassSupervision(idCliente){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'pass_supervision/'+ idCliente, requestOptions);
    },
    getEstadoActual(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'get_estado_actual', requestOptions);
    },
    verificaAnalistaCoordinadorResponsable(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'verifica_analista_coordinador_responsable/' + folio, requestOptions);
    },
    verificaCorreoTienda(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'verifica_correo_tienda/' + folio, requestOptions);
    },
    modificarAnalistaCoordinadorResponsable(folio,analista, coordinador){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "modifica_analista_coordinador/"+folio + "/"+analista + "/" + coordinador, requestOptions);
    },
    modificarInvRef(folio,inv_ref){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "modifica_inv_ref/"+folio + "/"+inv_ref , requestOptions);
    },
    detenerReportesAuto(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'detener_reportes_automaticos', requestOptions);
    },
    enviarDatosProductividad(folio,jornada){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'enviar_productividad/'+jornada+'/'+folio, requestOptions);
    },
    getRutaArchivosFinales(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'get_path_archivos_finales/'+folio, requestOptions);
    },
    verificaArchivosImportados(folio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'verifica_archivos_importados/'+folio, requestOptions);
    },
    modificarCorreoTienda(folio,correo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "modifica_correo_tienda/"+folio + "/"+correo, requestOptions);
    },
    getRevisionPrecios(page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 50,
            search: search ?? "",
            sort_field: sortField ?? "articulo",
            sort_dir: sortDir ?? "asc"
        });
        const token = localStorage.getItem('token');
        return fetch(`${api}/revision_precios?${params.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        });
    },
    modificaPreciobarra(barra,precio){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "precio_barra/"+barra + "/"+precio, requestOptions);
    },
    
  
};

export const importacionesResources ={
    obtenerImportaciones(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "importaciones" , requestOptions);
    },
    async importarFalabella(formData, ruta,fecha) {
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {'Authorization': "Bearer " + token,'Access-Control-Allow-Origin': '*'},
            body: formData
        };
        return await fetch(api + ruta + "/" + fecha, requestOptions);
    },
    async cargarArchivos(formData,folio) {
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {'Authorization': "Bearer " + token,'Access-Control-Allow-Origin': '*'},
            body: formData
        };
        return await fetch(api + "cargar_archivos/"+ folio, requestOptions);
    },
}

export const panelSodimacResources={
    getRegionesComerciales(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "regiones_comerciales_sodimac", requestOptions);
    },
    getRegionesPrevencion(region_comercial){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "regiones_prevencion_sodimac/" + region_comercial, requestOptions);
    },
    getPanelDiario(region_prevencion, page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "difimp",
            sort_dir: sortDir ?? "desc"
        });
        
        const token = localStorage.getItem('token');
        return fetch(`${api}panel_sodimac/diario/${region_prevencion}?${params.toString()}`, {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        });
    },
    getPanelSemanal(region_prevencion, page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "difimp",
            sort_dir: sortDir ?? "desc"
        });
        
        const token = localStorage.getItem('token');
        return fetch(`${api}panel_sodimac/semanal/${region_prevencion}?${params.toString()}`, {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        });
    },
    getPanelHistorico(region_prevencion, page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "difimp",
            sort_dir: sortDir ?? "desc"
        });
        
        const token = localStorage.getItem('token');
        return fetch(`${api}panel_sodimac/historico/${region_prevencion}?${params.toString()}`, {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        });
    },
    generarExcel(fecha_inicio, fecha_termino){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'genera_excel_panel_sodimac/'+ fecha_inicio + "/" + fecha_termino, requestOptions);
    },
    generarExcelValidacion(fecha){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'genera_excel_validacion_panel_sodimac/'+ fecha, requestOptions);
    },
    generarExcelConsoAudVisual(inicio_mes, termino_mes){
        const params = new URLSearchParams({
            inicio_mes: inicio_mes,
            termino_mes: termino_mes
        });
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'genera_excel_conso_aud_visual?' + params.toString(), requestOptions);
    },
    generarExcelConsoAudAltillo(inicio_mes, termino_mes){
        const params = new URLSearchParams({
            inicio_mes: inicio_mes,
            termino_mes: termino_mes
        });
        const token = localStorage.getItem('token')
        return fetch(`${api}/genera_excel_conso_aud_altillo?${params.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        });
    },
    generarExcelDetalleAudAltillo(inicio_mes, termino_mes){
        const params = new URLSearchParams({
            inicio_mes: inicio_mes,
            termino_mes: termino_mes
        });
        const token = localStorage.getItem('token')
        return fetch(`${api}/genera_excel_detalle_aud_altillo?${params.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        });
    },
    generarExcelConsoValidaciones(inicio_mes, termino_mes){
        const params = new URLSearchParams({
            inicio_mes: inicio_mes,
            termino_mes: termino_mes
        });
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'genera_excel_conso_validaciones?' + params.toString(), requestOptions);
    },
}

export const metrosResources = {
    agregarMetro(metro){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(metro)
        };
        return fetch(api + `create/metro`, requestOptions);
    },
    editarMetro(id, metro){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body:JSON.stringify(metro)
        };
        return fetch(api + `edit/metro/${id}` , requestOptions);
    },
    eliminarMetro(id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token }
        };
        return fetch(api + `delete/metro/${id}` , requestOptions);
    },
    eliminarMetros(idMetros){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers:  { "Content-Type": "application/json", 'Authorization': "Bearer "+ token },
            body: JSON.stringify(idMetros)
        };
        return fetch(api + "delete/metros/multiples" , requestOptions);
    }
}

export const pasillosResources = {
    getAvanceAuditoria(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "avance_auditoria_visual", requestOptions);
    },
    obtenerPasillos(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "pasillos", requestOptions);
    },
    obtenerPasillosSinAuditar(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "pasillos_sin_auditar", requestOptions);
    },
    obtenerPasillosAuditados(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "pasillos_auditados", requestOptions);
    },
    agregarPasillo(pasillo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(pasillo)
        };
        return fetch(api + `create/pasillo`, requestOptions);
    },
    editarPasillo(id,pasillo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(pasillo)
        };
        return fetch(api + `edit/pasillo/${id}` , requestOptions);
    },
    eliminarPasillo(id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token }
        };
        return fetch(api + `delete/pasillo/${id}` , requestOptions);
    },
    agregarPasillosAuditoria(pasillos){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(pasillos)
        };
        return fetch(api + "agregar_pasillos_auditoria" , requestOptions);
    },
}

export const ubicacionesResources={
    obtenerUbicaciones(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "ubicaciones", requestOptions);
    },
    agregarUbicacion(ubicacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(ubicacion)
        };
        return fetch(api + "create/ubicacion", requestOptions);
    },

    agregarUbicacionRango(ubicacionRango){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(ubicacionRango)
        };
        return fetch(api + "create/ubicacion_rango", requestOptions);
    },
    editarUbicacion(id,ubicacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(ubicacion)
        };
        return fetch(api + "edit/ubicacion/"+id , requestOptions);
    },

    editarUbicacionRango(idUbicacion,idRango,ubicacionRango){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(ubicacionRango)
        };
        return fetch(api + "edit/ubicacion_rango/"+idUbicacion + "/" + idRango , requestOptions);
    },

    eliminarUbicacion(id, idRango){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token }
        };
        return fetch(api + "delete/ubicacion/" +id +"/"+ idRango, requestOptions);
    },
    obtenerUbicacionesHijas(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "ubicaciones/hijas" , requestOptions);
    },
    getUbicacionesIniciales(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "ubicaciones_iniciales" , requestOptions);
    }
}

export const rangosResources={
    obtenerRangos(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "rangos" , requestOptions);
    },
    agregarRango(rango){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(rango)
        };
        return fetch(api + "create/rango" , requestOptions);
    },
    eliminarRango(id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token }
        };
        return fetch(api + "delete/rango/"+id , requestOptions);
    },
    editarRango(id,rango){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(rango)
        };
        return fetch(api + "edit/rango/"+id , requestOptions);
    }
}

export const tagResources ={
    obtenerTipoCampos(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tipo_campos", requestOptions);
    },
    consultarTag(tag,tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "consulta_tag/"+ tag+"/"+ tipo, requestOptions);
    },
    consultarUbicacionTag(tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "get_descripcion_ubicacion_tag/"+ tag, requestOptions);
    },
    totalesTag(tag,tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "totales_tag/"+tag+"/"+ tipo, requestOptions);
    },
    eliminarTag(tag,id_motivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "tag/" + tag + "/" + id_motivo , requestOptions);
    },
    getTagsConflictos(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "conflicto_tag", requestOptions);
    },
    resolverConflictoTag(tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "conflicto_tag/"+ tag + "/t", requestOptions);
    },
    desResolverConflicto(tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "conflicto_tag/"+ tag + "/f", requestOptions);
    },
    detalleTagConflicto(tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "detalle_conflicto/" + tag, requestOptions);
    },
    getCodigosTipos(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "codigo_tipo", requestOptions);
    },
    restaurarTagEliminado(tag,id_motivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'tag/undelete/' + tag + "/" + id_motivo, requestOptions);
    },
    getIdTag(tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'get_id_tag/' + tag , requestOptions);
    },
    agregarConteo(datosConteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosConteo)
        };
        return fetch(api + "agregar_conteo", requestOptions);
    },
    verificaCodigoExiste(codigo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "verifica_existe_codigo/"+ codigo, requestOptions);
    },
    verificaCodigoTipo(codigo,codigo_tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "verifica_codigo_tipo/"+ codigo +"/" +codigo_tipo, requestOptions);
    },
    getValidacionTag(tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "tag_validado/"+ tipo, requestOptions);
    },
    existenDuplicados(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "existen_duplicados", requestOptions);
    },
    eliminarDescargaTag(id_archivo,tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "eliminar/descarga/" + id_archivo + "/" + tag , requestOptions);
    },
    recuperarDescargaTag(id_archivo,tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "recuperar/descarga/" + id_archivo + "/" + tag , requestOptions);
    },
    consultarDescargaTag(tag,id_archivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "consulta_descarga_tag/"+ tag+"/"+ id_archivo, requestOptions);
    },
    getNegativos(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "get_negativos", requestOptions);
    },
}

export const validacionWalmart ={
    corrigeTimestamp(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "corrige_timestamp", requestOptions);
    },
    verificaiconTimestampWalmart(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "verifica_timestamp_walmart" , requestOptions);
    },
    getValidacionTagWalmart(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "tags_validados_walmart", requestOptions);
    },
    guardaSupRecontadorWalmart(sup_ap,recontador){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "put_recontador_nombre_walmart/" +recontador + "/"+sup_ap , requestOptions);
    },
    getRecontadorSupAp(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "recontador_sup_ap_walmart", requestOptions);
    },
    guardarMotivoError(tag,motivo,error){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "put_motivo_error_walmart/"+tag+"/" +motivo + "/"+error , requestOptions);
    },
    guardarMotivoErrorMandatorios(tag,motivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "put_motivo_error_mandatorios_walmart/"+tag+"/" +motivo, requestOptions);
    },
    getRnr(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "rnr_walmart", requestOptions);
    },
    getDeptosWalmart(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "get_deptos_walmart", requestOptions);
    },
    createRnr(depto,cantidad,importe){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "create_rnr/" +depto + "/"+cantidad + "/" + importe , requestOptions);
    },
    deleteRnr(id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers:  { "Content-Type": "application/json", 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "delete_rnr/"+ id , requestOptions);
    },
    updateRnr(id,depto,cantidad,importe){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "update_rnr/"+id+"/" +depto + "/"+cantidad +"/" + importe , requestOptions);
    },
    getValoresCaminadoTickets(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "caminado_tickets", requestOptions);
    },
    updateCaminadoTickets(datosCaminado){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers:  { "Content-Type": "application/json", 'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosCaminado)
        };
        return fetch(api + "update_caminado_tickets", requestOptions);
    },
}

export const validacionTagResources ={
    getValidacionCambioCodigos(tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "cambios_codigos_validado/"+ tipo, requestOptions);
    },
    getTotales(tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "totales_validacion/"+ tipo, requestOptions);
    },
    editarCantidadValidacionTag(tag,cantidad,tipo,codigo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "edit/tag_validado/"+ tag + "/" + cantidad+"/"+ tipo +"/"+ codigo, requestOptions);
    },
    getValidacionCantidadPorCodigo(tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "cantidad_por_codigo_validado/"+ tipo, requestOptions);
    },
}

export const avanceResources ={
    getAvanceUbicacion(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "avance_ubicaciones" , requestOptions);
    },
    getHgetAvanceUbicacionZona(id){
        const token = localStorage.getItem('token')

        return fetch(api + `avance_ubicaciones_zona?id_padre=${id}`, {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        })
    },
    getTagsContadosUbicacion(idUbicacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tag/contado/ubicacion/"+ idUbicacion , requestOptions);
    },
    getTagsPendientesUbicacion(idUbicacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tag/pendiente/ubicacion/"+ idUbicacion , requestOptions);
    },
    getTagsNulosUbicacion(idUbicacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tag/nulo/ubicacion/"+ idUbicacion , requestOptions);
    },
    getAvanceGeneral(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "avance_general", requestOptions);
    },
    getTagsOperador(operador){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tag_operador/"+ operador , requestOptions);
    },
}

export const  forzadosResources ={
    eliminarForzados(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "eliminar_forzados", requestOptions);
    },
    existenForzados(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "existen_forzados", requestOptions);
    },
    getTagForzados(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tag_forzados", requestOptions);
    },
    recuperarForzados(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "recuperar_forzados", requestOptions);
    }
}

export const anularTagsResources ={
    getMotivosAnular(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "motivos_anular" , requestOptions);
    },
    agregarTagNulo(datosTagNulo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosTagNulo)
        };
        return fetch(api + "create/tag_nulo" , requestOptions);
    },
    desAnularTag(tags){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers:  { "Content-Type": "application/json", 'Authorization': "Bearer "+ token },
            body: JSON.stringify(tags)
        };
        return fetch(api + "delete/tag_nulo" , requestOptions);
    }
}

export const diferenciasResources={
    getDiferencias(page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "id",
            sort_dir: sortDir ?? "asc"
        });
        const token = localStorage.getItem('token');
        return fetch(`${api}diferencias?${params.toString()}`, {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        });
    },
    getDiferenciasPorUbicacion(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "diferencias_ubicacion", requestOptions);
    },
    getDiferenciasConteoCero(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "diferencias_conteo_cero", requestOptions);
    },
    getDifJerarquia(idJerarquia,filtro,valor){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "diferencias_jerarquia/" + idJerarquia +"/"+ filtro + "/" + valor, requestOptions);
    },
    getDifUbicacion(idUbicacion,filtro,valor){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "diferencias_ubicacion/" + idUbicacion +"/"+ filtro + "/" + valor, requestOptions);
    },
    getDifProducto(producto){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "diferencias_producto/" + producto, requestOptions);
    },
    getDatosJerarquia(jerarquia){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "descripcion_jerarquia/" + jerarquia, requestOptions);
    },
    getDatosUbicacion(ubicacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "descripcion_ubicacion/" + ubicacion, requestOptions);
    },
    getDatosProducto(producto){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "descripcion_producto/" + producto, requestOptions);
    },
    enviaMailRecuento(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "mail/recuento", requestOptions);
    },
    getRecuento(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "recuento", requestOptions);
    },
    getDiferenciaGeneral(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        }
        return fetch(api + "consultar_diferencia", requestOptions);
    },
}

export const reportesResources={
    getReportesDisponibles(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "reportes_disponibles", requestOptions);
    },
    getZonas(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "zonas_reportes", requestOptions);
    },
    operadores_reportes(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "operadores_reportes", requestOptions);
    },
    tag_operador(usuario){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tags_operador_reportes/"+usuario, requestOptions);
    },
    getTagZonaPorcentaje(idUbicacion,porcentaje,monto){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tag_zona/" + idUbicacion + "/" + porcentaje + "/" + monto, requestOptions);
    },
    enviarDatosReportes(datosExportar){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { 'Content-Type': 'application/json',
                'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosExportar)
        };
        return fetch(api + "genera_reporte" , requestOptions);
    },
    getReportesParaRevisar(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "reportes_para_revisar", requestOptions);
    },
    modificaEstadoRevisionReportes(id_reporte,id_estado){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "modifica_estado_revision_reporte/"+id_reporte+"/" +id_estado, requestOptions);
    }
}

export const clientesResources={
    getClientes(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'clientes', requestOptions);
    },
    getTiendasCliente(idCliente){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'tiendas_cliente/' + idCliente, requestOptions);
    }
}

export const exportacionesResources={
    getExportaciones(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'exportaciones', requestOptions);
    },
    exportar(ruta){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + ruta, requestOptions);
    },
}

export const detalleResources={
    getDetalleConteo(id_conteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'detalles_conteo/' + id_conteo, requestOptions);
    },
    getDetalleAjustesConteo(id_conteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'detalles_conteo/ajuste/' + id_conteo, requestOptions);
    },
    getDetalleConteoAgrupado(codigo,codigo_tipo,tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'detalles_conteo/agrupado/' + codigo + "/" + codigo_tipo +"/" + tag, requestOptions);
    },
    getDetalleAjusteAgrupado(tag,codigo,codigo_tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'ajuste/agrupado/' + tag + "/" + codigo + "/"+ codigo_tipo, requestOptions);
    },
}

export const ajustesResources={
    getDetallesProducto(producto){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "detalle_producto/" + producto, requestOptions);
    },
    getMotivosAjustes(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'ajustes_motivos', requestOptions);
    },
    ajustarCantidadDesagrupado(datosConteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosConteo)
        };
        return fetch(api + "conteo", requestOptions);
    },
    ajustarCantidadAgrupado(datosConteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosConteo)
        };
        return fetch(api + "conteo/agrupado", requestOptions);
    },
    ajustarDatos(id, conteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(conteo)
        };
        return fetch(api + "update_datos_conteo/" + id, requestOptions);
    },
    getAllAjustes(tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'get_all_ajustes/'+ tipo, requestOptions);
    },
    rechazarAjuste(id_conteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "rechazar_ajuste/" + id_conteo, requestOptions);
    },
    aprobarAjuste(id_conteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "aprobar_ajuste/" + id_conteo, requestOptions);
    },
    aprobarTodas(tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "aprobar_all_ajustes/" +tipo, requestOptions);
    },
    ajustarCantidadValidacion(id,cantidad,id_motivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "conteo_validacion/" + id + "/" + cantidad + "/" + id_motivo , requestOptions);
    },
    rechazarAjusteCliente(id_ajuste){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "rechazar_ajuste_de_cliente/" + id_ajuste, requestOptions);
    },
    aprobarAjusteCliente(id_ajuste){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "aprobar_ajuste_de_cliente/" + id_ajuste, requestOptions);
    },
}

export const eliminarConteoResources ={
    eliminarConteoDesagrupado(id_conteo,id_motivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "eliminar/conteo/" + id_conteo + "/" + id_motivo , requestOptions);
    },
    eliminarConteoAgrupado(tag,codigo,codigo_tipo,id_motivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token },
        };
        return fetch(api + "eliminar/conteo/agrupado/" + tag + "/" + codigo_tipo + "/" + codigo +"/" + id_motivo , requestOptions);
    },
    restaurarConteoEliminado(id,id_motivo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'conteo/undelete/' + id + "/" + id_motivo, requestOptions);
    }
}

export const observacionesResources ={
    getObservaciones(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'observaciones', requestOptions);
    },
    createObservacion(datosObservacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosObservacion)
        };
        return fetch(api + "create/observacion" , requestOptions);
    },
    getPrioridadesObs(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'prioridades', requestOptions);
    },
    editarObservacion(datosObservacion,id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosObservacion)
        };
        return fetch(api + "update/observacion/" + id, requestOptions);
    },
    deleteObservacion(id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token }
        };
        return fetch(api + "delete/observacion/" +id , requestOptions);
    },
    getUsuarioObservacion(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'get_usuario_observacion', requestOptions);
    },
    createObservacionUsuario(datosObservacion){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosObservacion)
        };
        return fetch(api + "create/observacion/usuario" , requestOptions);
    }
}

export const historialResources= {
    getHistorial() {
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'historial', requestOptions);
    },
}

export const revisarResources={
    revisarConteo(id_conteo, origen) {
        const token = localStorage.getItem('token');
        const origenCodificado = encodeURIComponent(origen);
        return fetch(`${api}revisar_conteo/${id_conteo}?origen=${origenCodificado}`, {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                'Authorization': "Bearer " + token 
            }
        });
    },
    revisarConteoAgrupado(tag,codigo,id_codigo_tipo,origen){
        const token = localStorage.getItem('token')
        const origenCodificado = encodeURIComponent(origen);
        return fetch(`${api}revisar_conteo/agrupado/${tag}/${codigo}/${id_codigo_tipo}?origen=${origenCodificado}`, {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                'Authorization': "Bearer "+ token }
        });
    },
    desrevisarConteo(id_conteo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token }
        };
        return fetch(api + "desrevisar_conteo/" + id_conteo , requestOptions);
    },
    desrevisarContepAgrupado(tag,codigo,id_codigo_tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token }
        };
        return fetch(api +  "desrevisar_conteo/agrupado/"+ tag +"/" +codigo +"/"+id_codigo_tipo, requestOptions);
    },
    getRevisionTag(tag){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'consulta_tag_revisado/' +  tag, requestOptions);
    },
    revisarTag(tag) {
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json", 'Authorization': "Bearer " + token}
        };
        return fetch(api + "revisar_tag/" + tag, requestOptions);
    },
    desrevisarTag(tag) {
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json", 'Authorization': "Bearer " + token}
        };
        return fetch(api + "desrevisar_tag/" + tag, requestOptions);
    },
    revisarConteoCero(articulo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token }
        };
        return fetch(api + "revisar_conteo_cero/" + articulo , requestOptions);
    },
    verificaConteoCeroRevisado(articulo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'verifica_conteo_cero_revisado/' +  articulo, requestOptions);
    },
    desrevisarConteoCero(articulo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token }
        };
        return fetch(api + "desrevisar_conteo_cero/" + articulo , requestOptions);
    },
}

export const procesosResources={
    getProcesos(page,pageSize,search){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'get_procesos?page=' +page+'&size='+pageSize +'&search='+search, requestOptions);

    },
}

export const sistemaResources ={
    getVersion(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'get_version', requestOptions);
    },
}

export const wallmartResources ={
    getItemFile(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'wallmart_get_itemfile', requestOptions);
    },
    getZonas(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'wallmart_get_zonas', requestOptions);
    },
    getPreconteo(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + 'wallmart_get_precount_data', requestOptions);
    },
    putCount(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + "wallmart_put_count", requestOptions);
    },
    putAcknowledgeCount(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + "wallmart_acknowledge_precount_data", requestOptions);
    },
    postReceiveTagSummary(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + "wallmart_receive_tag_summary_info", requestOptions);
    },
    postReceiveTagDetails(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + "wallmart_receive_tag_details", requestOptions);
    },
    getRecountAdjustments(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + "wallmart_get_recount_adjustments", requestOptions);
    },
    putAcknowledgeRecount(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: {'Authorization': "Bearer " + token}
        };
        return fetch(api + "wallmart_put_recount_adjustment_data", requestOptions);
    },
}


export const auditoriaEstandarResources ={
    createAuditoria(datosAuditoria){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json",'Authorization': "Bearer " + token},
            body: JSON.stringify(datosAuditoria)
        };
        return fetch(api + "create/auditoria", requestOptions);
    },
}

export const CheckListResources ={
    getValores(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'valores_check_list', requestOptions);
    },
    postImages(formData,id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers:{'Authorization': "Bearer "+ token},
            body: formData
        };
        return fetch(api + "upload_images/" + id, requestOptions);
    },
    updateCheckList(datosCheckList){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers:  { "Content-Type": "application/json", 'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosCheckList)
        };
        return fetch(api + "update_check_list", requestOptions);
    },

}

export const ValidacionConteoResources={
    getValores(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'valores_validacion_conteo', requestOptions);
    },
    getResumen(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'resumen_validacion_conteo', requestOptions);
    },
    getConteosSignificativos(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'conteos_significativos', requestOptions);
    },
    getCantidadesRevisar(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'cantidades_revisar', requestOptions);
    }
}

export const validadorClienteResources={
    getValidadorCliente(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'validadores_cliente', requestOptions);
    },
    createValidador(datosValidador){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosValidador)
        };
        return fetch(api + "create/validador_cliente" , requestOptions);
    },
    editarValidadorCliente(datosValidador,cod_operador){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datosValidador)
        };
        return fetch(api + "update/validador_cliente/" + cod_operador, requestOptions);
    },
    deleteValidador(cod_operador){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token }
        };
        return fetch(api + "delete/validador_cliente/" +cod_operador , requestOptions);
    },
    defineEncargadoTienda(cod_encargado){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
        };
        return fetch(api + "define_encargado_tienda/" + cod_encargado, requestOptions);
    },
}

export const highDollarResources={
    getHighDollar (inicio, valor,tipo){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'high_dollar/' + inicio + '/' + valor  + '/' +  tipo, requestOptions);
    },
}

export const tagsEspejoMandatorioResources ={
    getTagsEspejo(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + "tags_espejo_mandatorio" , requestOptions);
    },
}

export const productividadResources = {
    getRendimiento(){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "GET",
            headers:{'Authorization': "Bearer "+ token}
        };
        return fetch(api + 'rendimiento', requestOptions);
    },
    getProductividadPorcliente(params = {}) {
        const token = localStorage.getItem('token');
        const query = new URLSearchParams(params).toString();

        return fetch(`${api}productividad_por_cliente?${query}`, {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        });
    },
    getProductividadPorUsuario(params = {}) {
        const token = localStorage.getItem('token');
        const query = new URLSearchParams(params).toString();

        return fetch(`${api}productividad_por_usuario?${query}`, {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        });
    },
}

export const panelGeneralResources = {
    getInventariosPanelGeneral(page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "fecha",
            sort_dir: sortDir ?? "desc"
        });
        const token = localStorage.getItem('token');
        return fetch(`${api}panel_general?${params.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        });
    },
    getAuditoriasPanelGeneral(page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "fecha",
            sort_dir: sortDir ?? "desc"
        });
        const token = localStorage.getItem('token')

        return fetch(`${api}/panel_auditorias?${params.toString()}`, {
            method: "GET",
            headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
            }
        });
    },
    getAuditoriasPanelAltillo(page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "mes",
            sort_dir: sortDir ?? "desc"
        });
        const token = localStorage.getItem('token')

        return fetch(`${api}/panel_auditorias_altillo?${params.toString()}`, {
            method: "GET",
            headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
            }
        });
    },
     getAuditoriasPanelVisual(page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "mes",
            sort_dir: sortDir ?? "desc"
        });
        const token = localStorage.getItem('token')

        return fetch(`${api}/panel_auditorias_visual?${params.toString()}`, {
            method: "GET",
            headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
            }
        });
    },
    getAuditoriasPanelAltilloDetalle(tienda, mes, page, pageSize, search,sortField, sortDir) {
        const params = new URLSearchParams({
            tienda: tienda,
            mes: mes, // formato "YYYY-MM"
            page: page ?? 0,
            page_size: pageSize ?? 25,
            search: search ?? "",
            sort_field: sortField ?? "fecha",
            sort_dir: sortDir ?? "desc"
        });

        const token = localStorage.getItem('token');

        return fetch(`${api}/panel_auditorias_altillo_detalle?${params.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        });
    }
}

export const checkInternetResources = {
    checkInternet(){
        const requestOptions = {
            method: "GET",
        };
        return fetch(api + 'check_connect', requestOptions);
    },
}

export const controlRespaldoResources = {
    getControlRespaldos(page, pageSize, search, sortField, sortDir) {
        const params = new URLSearchParams({
            page: page ?? 0,
            page_size: pageSize ?? 50,
            search: search ?? "",
            sort_field: sortField ?? "fecha_jornada",
            sort_dir: sortDir ?? "desc"
        });
        const token = localStorage.getItem('token');
        return fetch(`${api}/control_respaldos?${params.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        });
    },
    agregarControlRespaldo(datos){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json",'Authorization': "Bearer "+ token },
            body: JSON.stringify(datos)
        };
        return fetch(api + "create/control_respaldos", requestOptions);
    },
    eliminarControlRespaldo(id){
        const token = localStorage.getItem('token')
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer "+ token }
        };
        return fetch(api + `delete/control_respaldos/${id}` , requestOptions);
    },
    editarTipoJornada(idControlRespaldos, tipoJornada) {
        const token = localStorage.getItem('token');
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                'Authorization': "Bearer " + token
            }
        };
        return fetch(`${api}edit/control_respaldos/tipo_jornada/${idControlRespaldos}/${tipoJornada}`, requestOptions);
    }
};

export const gestionArchivosResources = {
    getArchivos() {
        const token = localStorage.getItem('token');
        const requestOptions = {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        };
        return fetch(api + "client/files", requestOptions);
    },

    subirArchivo(formData) {
        const token = localStorage.getItem('token');
        const requestOptions = {
            method: "POST",
            headers: { 
                'Authorization': "Bearer " + token
            },
            body: formData
        };
        return fetch(api + "client/files/upload", requestOptions);
    },

    descargarArchivo(fileId) {
        const token = localStorage.getItem('token');
        const requestOptions = {
            method: "GET",
            headers: { 'Authorization': "Bearer " + token }
        };
        return fetch(api + "client/files/" + fileId + "/download", requestOptions);
    },

    eliminarArchivo(fileId) {
        const token = localStorage.getItem('token');
        const requestOptions = {
            method: "DELETE",
            headers: { 'Authorization': "Bearer " + token }
        };
        return fetch(api + "client/files/" + fileId, requestOptions);
    }
};